import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AuthenticationGuard } from './authentication.guard';
import { SessionService } from './session.service';
import { SessionAlertComponent } from './session-alert/session-alert.component';
import { StorageTool } from './storage.tool';
import { IonicStorageModule } from '@ionic/storage';
export * from './session.service';
export * from './authentication.guard';
export * from './storage.tool';


@NgModule({
  declarations: [SessionAlertComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
  ],
  providers: [
    StorageTool,
    SessionService,
    AuthenticationGuard,
  ],
  exports: [
    SessionAlertComponent,
  ]
})
export class SessionModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SessionModule,
    };
  }
 }
